import './style.css';
import {
  LuCircleCheck,
  LuDatabase,
  LuFileCheck2,
  LuFileText,
  LuFolderOpen,
  LuScan,
} from 'react-icons/lu';

const dataIcons = {
  format: LuFileText,
  volume: LuDatabase,
  additionalMaterials: LuFolderOpen,
  coverage: LuScan,
  result: LuFileCheck2,
};

const ProjectData = ({ data }) => {
  if (!data?.items?.length) return null;

  return (
    <section className="project-data project-case-card">
      <h2 className="project-case-card__title">{data.title}</h2>

      <div className={`project-data__metrics${data.items.length === 4 ? ' project-data__metrics--four' : ''}`}>
        {data.items.map(({ id, label, value }) => {
          const Icon = dataIcons[id];
          return (
          <article key={id} className="project-data__metric">
            <LuCircleCheck className="project-data__metric-check" aria-hidden="true" />
            <span className="project-case-icon project-data__metric-icon">
              {Icon ? <Icon /> : null}
            </span>
            <strong>{label}</strong>
            <span>{value}</span>
          </article>
          );
        })}
      </div>

      <div className="project-case-card__divider" />

      <h3 className="project-data__subtitle">{data.capturedTitle}</h3>

      <ul className="project-data__list">
        {(data.capturedItems || []).map(({ id, label }) => (
          <li key={id} className="project-data__item">
            <LuCircleCheck className="project-data__item-icon" aria-hidden="true" />
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectData;
